/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { PageThemeFlyout } from "components/navigationBar/PageThemeFlyout";
import { withTheme } from "context/themeContext";

const mapStoreToProps = (stores, ownProps) => ({
  intl: ownProps.intl,
  handlePanelToggle: ownProps.handlePanelToggle,
  showFlyover: ownProps.showFlyover,
  isDarkPageThemeEnabled: stores.pageThemeSwitcherStore.isDarkPageThemeEnabled,
  docViewTheme: stores.pageThemeSwitcherStore.docViewTheme,
  isDarkPageThemeSwitchDisabled: stores.pageThemeSwitcherStore.isDarkPageThemeSwitchDisabled,
  setDocViewTheme: stores.pageThemeSwitcherStore.setDocViewTheme,
  changeAppTheme: stores.pageThemeSwitcherStore.changeAppTheme,
  setDarkPageTheme: stores.pageThemeSwitcherStore.setDarkPageTheme,
  userPrefThemeCallback: stores.pageThemeSwitcherStore.userPrefThemeCallback,
  customReadingThemesSet: stores.pageThemeSwitcherStore.customReadingThemesSet
});

const PageThemeFlyoutContainer = inject(mapStoreToProps)(withTheme(PageThemeFlyout));

export { PageThemeFlyoutContainer };
